import React, { useState } from "react";
import { Modal, message } from "antd";
import { useTranslation } from "../i18n/useTranslation";
import { Button } from "./ui/button";

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const ContactModal = ({ open, onClose }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    name: "",
    email: "",
    content: "",
  });
  const [errors, setErrors] = useState({});

  const validate = () => {
    const next = {};
    if (!form.name.trim()) next.name = t("contactModalNameRequired");
    if (!form.email.trim()) next.email = t("contactModalEmailRequired");
    else if (!EMAIL_REGEX.test(form.email)) next.email = t("contactModalEmailInvalid");
    if (!form.content.trim()) next.content = t("contactModalContentRequired");
    setErrors(next);
    return Object.keys(next).length === 0;
  };

  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
    if (errors[field]) setErrors((prev) => ({ ...prev, [field]: undefined }));
  };

  const handleSubmit = () => {
    if (!validate()) return;
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      message.success(t("contactModalSuccess"));
      setForm({ name: "", email: "", content: "" });
      setErrors({});
      onClose();
    }, 500);
  };

  const handleCancel = () => {
    setForm({ name: "", email: "", content: "" });
    setErrors({});
    onClose();
  };

  const inputClass = "w-full px-3 py-2 border rounded-md outline-none focus:ring-2 focus:ring-blue-500";
  const inputErrorClass = "border-red-500";

  return (
    <Modal
      title={t("contactModalTitle")}
      open={open}
      onCancel={handleCancel}
      footer={null}
      width={480}
      destroyOnClose
      styles={{ header: { textAlign: "center" } }}
    >
      <div className="space-y-4 pt-2">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">{t("contactModalName")}</label>
          <input
            type="text"
            value={form.name}
            onChange={(e) => handleChange("name", e.target.value)}
            className={`${inputClass} ${errors.name ? inputErrorClass : "border-gray-300"}`}
            placeholder={t("contactModalNamePlaceholder")}
          />
          {errors.name && <p className="text-red-500 text-xs mt-1">{errors.name}</p>}
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">{t("contactModalEmail")}</label>
          <input
            type="email"
            value={form.email}
            onChange={(e) => handleChange("email", e.target.value)}
            className={`${inputClass} ${errors.email ? inputErrorClass : "border-gray-300"}`}
            placeholder={t("contactModalEmailPlaceholder")}
          />
          {errors.email && <p className="text-red-500 text-xs mt-1">{errors.email}</p>}
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">{t("contactModalContent")}</label>
          <textarea
            value={form.content}
            onChange={(e) => handleChange("content", e.target.value)}
            rows={4}
            className={`${inputClass} resize-none ${errors.content ? inputErrorClass : "border-gray-300"}`}
            placeholder={t("contactModalContent")}
          />
          {errors.content && <p className="text-red-500 text-xs mt-1">{errors.content}</p>}
        </div>
        <div className="pt-2">
          <Button
            variant="blue-griadient"
            size="lg"
            className="w-full"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? "..." : t("contactModalSend")}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ContactModal;
